import api from "apis";
import { PropsWithChildren, useEffect } from "react";
import {
  JWT_KEY,
  NOTIFICATION_ROUTER_PATH,
  PUSH_NOTIFICATION_TYPE,
} from "./constant";

const BridgeProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    window.sendFCMToken = async (token: string) => {
      const result = await api.user.saveFcmToken({ fcmToken: token });
      return result.data.isSuccess;
    };

    window.isLoggedIn = (): boolean => {
      const jwt = window.localStorage.getItem(JWT_KEY);

      // JWT가 undefined거나 null이 아니고, trim() 후 길이가 0보다 크면 true
      if (jwt === undefined || jwt === null || jwt.trim().length <= 0) {
        return false;
      }

      // JWT 형식 검증
      const [header, payload, signature] = jwt.split(".");
      if (!header || !payload || !signature) return false;

      // JWT 토큰 만료 여부 확인
      const expirationTime = JSON.parse(atob(payload)).exp;
      if (Date.now() >= expirationTime) {
        return false;
      }

      return true;
    };

    const performNavigation = (
      targetUuid: string,
      type: string,
      category: string,
    ) => {
      switch (type) {
        // 공지사항 등록 -> 공지사항 상세페이지
        case PUSH_NOTIFICATION_TYPE.NOTICE_REGISTRATION:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.NOTICE_REGISTRATION(targetUuid));

        // ANALYSIS 1단계 결재 요청 -> 해당 문서 결재 상세페이지
        case PUSH_NOTIFICATION_TYPE.REQUEST_REVIEW:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.REQUEST_REVIEW(targetUuid));

        // ANALYSIS 2단계 결재 요청 -> 해당 문서 결재 상세페이지
        case PUSH_NOTIFICATION_TYPE.REQUEST_APPROVAL:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.REQUEST_APPROVAL(targetUuid));

        // WORK 결재 요청 -> 해당 문서 결재 상세페이지
        case PUSH_NOTIFICATION_TYPE.REQUEST_NOT_ANALYSIS:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.REQUEST_NOT_ANALYSIS(targetUuid));

        // 보완 요청 -> mydesk 보완요청 필터링 리스트 보여주기
        case PUSH_NOTIFICATION_TYPE.REQ_SUPPLEMENT:
          return category === "WORK"
            ? (window.location.href =
                NOTIFICATION_ROUTER_PATH.REQ_SUPPLEMENT.WORK)
            : (window.location.href =
                NOTIFICATION_ROUTER_PATH.REQ_SUPPLEMENT.ANALYSIS);

        // ANALYSIS 문서 1단계 승인 완료
        case PUSH_NOTIFICATION_TYPE.REVIEW:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.REVIEW(targetUuid));

        // ANALYSIS 문서 2단계 승인 완료
        case PUSH_NOTIFICATION_TYPE.APPROVE:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.APPROVE(targetUuid));

        // WORK 문서 승인 완료
        case PUSH_NOTIFICATION_TYPE.APPROVE_NOT_ANALYSIS:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.APPROVE_NOT_ANALYSIS(targetUuid));

        // Archieve 문서 등록 -> Archives 문서 리스트 페이지
        case PUSH_NOTIFICATION_TYPE.ARCHIVES_REGISTRATION:
          return (window.location.href =
            NOTIFICATION_ROUTER_PATH.ARCHIVES_REGISTRATION);

        default:
          return;
      }
    };

    window.handlePushNavigate = (
      targetUuid: string,
      type: string,
      category: string,
    ) => {
      const attemptNavigation = (attempts = 0, maxAttempts = 10) => {
        // 앱 준비 상태 확인
        const isReady =
          document.querySelector("#root")?.children.length &&
          document.readyState === "complete" &&
          window.location.pathname;

        if (isReady) {
          performNavigation(targetUuid, type, category);
        } else if (attempts < maxAttempts) {
          // 1초 후 재시도
          setTimeout(() => attemptNavigation(attempts + 1, maxAttempts), 1000);
        } else {
          console.error("Navigation failed: App not ready");
        }
      };

      attemptNavigation();
    };

    window.clickBanner = async (pushNotificationId: number) => {
      const result =
        await api.pushNotification.updatePushNotification(pushNotificationId);
      return result.data.isSuccess;
    };
  }, []);
  return children;
};

export default BridgeProvider;
